(function () {
  'use strict';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    var parts = amount.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + ' €';
  }

  var confettiLoadPromise = null;
  function loadConfettiLib() {
    if (typeof confetti === 'function') return Promise.resolve();
    if (confettiLoadPromise) return confettiLoadPromise;
    confettiLoadPromise = new Promise(function (resolve, reject) {
      if (!window.confettiAssetUrl) { reject(new Error('confettiAssetUrl missing')); return; }
      var s = document.createElement('script');
      s.src = window.confettiAssetUrl;
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('confetti script failed to load')); };
      document.head.appendChild(s);
    });
    return confettiLoadPromise;
  }

  function fireConfetti(panelEl) {
    loadConfettiLib().then(function () {
      if (typeof confetti !== 'function') return;
      var originX = 0.9;
      var originY = 0.88;
      if (panelEl) {
        var rect = panelEl.getBoundingClientRect();
        originX = Math.min(0.99, Math.max(0.05, (rect.right - 28) / window.innerWidth));
        originY = Math.min(0.99, Math.max(0.05, (rect.bottom - 40) / window.innerHeight));
      }
      var count = 200;
      var defaults = { origin: { x: originX, y: originY }, angle: 130, zIndex: 100000, disableForReducedMotion: true };
      function fire(particleRatio, opts) {
        confetti(Object.assign({}, defaults, opts, { particleCount: Math.floor(count * particleRatio) }));
      }
      fire(0.25, { spread: 30, startVelocity: 50 });
      fire(0.2, { spread: 55 });
      fire(0.35, { spread: 75, decay: 0.91, scalar: 0.8 });
      fire(0.1, { spread: 90, startVelocity: 22, decay: 0.92, scalar: 1.2 });
      fire(0.1, { spread: 90, startVelocity: 40 });
    }).catch(function () {});
  }

  function init() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var panelEl = drawer.querySelector('.cart-drawer__panel');
    var itemsEl = drawer.querySelector('[data-cart-drawer-items]');
    var emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
    var footerEl = drawer.querySelector('[data-cart-drawer-footer]');
    var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
    var summaryEl = drawer.querySelector('[data-cart-drawer-summary]');
    var summarySubtotalEl = drawer.querySelector('[data-cart-drawer-summary-subtotal]');
    var summaryDiscountEl = drawer.querySelector('[data-cart-drawer-summary-discount]');
    var shippingEl = drawer.querySelector('[data-cart-drawer-shipping]');
    var discountInput = drawer.querySelector('[data-cart-drawer-discount-input]');
    var discountApplyBtn = drawer.querySelector('[data-cart-drawer-discount-apply]');
    var discountMsgEl = drawer.querySelector('[data-cart-drawer-discount-message]');
    var discountAppliedEl = drawer.querySelector('[data-cart-drawer-discount-applied]');
    var freeShippingThreshold = parseFloat(drawer.getAttribute('data-free-shipping-threshold') || '0');
    var isBusy = false;
    var freeShippingUnlocked = false;
    var freeShippingStateKnown = false;

    function setBusy(busy) {
      isBusy = busy;
      drawer.classList.toggle('is-busy', busy);
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cart-drawer-open');
      fetchCart();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cart-drawer-open');
      document.body.classList.remove('drawer--open');
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str == null ? '' : String(str);
      return div.innerHTML;
    }

    function renderShippingBar(cart) {
      if (!shippingEl) return;
      if (!freeShippingThreshold) {
        shippingEl.innerHTML = '';
        return;
      }
      var thresholdCents = Math.round(freeShippingThreshold * 100);
      var remaining = thresholdCents - cart.total_price;
      var isUnlocked = remaining <= 0;

      if (isUnlocked) {
        shippingEl.innerHTML =
          '<div class="cart-drawer__shipping-message cart-drawer__shipping-message--done">' +
          '<span class="cart-drawer__shipping-icon cart-drawer__shipping-icon--done"><svg viewBox="0 0 20 20" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 10l4 4 8-8"/></svg></span>' +
          '<span>Du hast dir kostenlosen Versand gesichert!</span></div>' +
          '<div class="cart-drawer__shipping-bar"><div class="cart-drawer__shipping-bar-fill" style="width:100%"></div></div>';
      } else {
        var pct = Math.max(0, Math.min(100, (cart.total_price / thresholdCents) * 100));
        shippingEl.innerHTML =
          '<div class="cart-drawer__shipping-message">' +
          '<span class="cart-drawer__shipping-icon"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg></span>' +
          '<span>Noch <strong>' + formatMoney(remaining) + '</strong> bis zum kostenlosen Versand</span></div>' +
          '<div class="cart-drawer__shipping-bar"><div class="cart-drawer__shipping-bar-fill" style="width:' + pct + '%"></div></div>';
      }

      if (freeShippingStateKnown && isUnlocked && !freeShippingUnlocked) {
        fireConfetti(panelEl);
      }
      freeShippingUnlocked = isUnlocked;
      freeShippingStateKnown = true;
    }

    function renderSummary(cart) {
      if (!summaryEl) return;
      var totalDiscount = cart.total_discount || 0;
      if (totalDiscount > 0) {
        summaryEl.hidden = false;
        var originalTotal = cart.original_total_price != null ? cart.original_total_price : (cart.total_price + totalDiscount);
        summarySubtotalEl.textContent = formatMoney(originalTotal);
        summaryDiscountEl.textContent = '−' + formatMoney(totalDiscount);
      } else {
        summaryEl.hidden = true;
      }
    }

    function renderDiscount(cart) {
      var applications = cart.cart_level_discount_applications || [];
      if (applications.length > 0) {
        discountAppliedEl.hidden = false;
        discountAppliedEl.innerHTML = applications.map(function (d) {
          var app = d.discount_application || d;
          var title = app.title || d.title || 'Rabatt';
          return '<span class="cart-drawer__discount-chip">' +
            '<svg viewBox="0 0 20 20" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 10l2.5 2.5L14 7"/></svg>' +
            escapeHtml(title) +
            '<button type="button" class="cart-drawer__discount-remove" data-remove-discount aria-label="Rabattcode entfernen">×</button></span>';
        }).join('');
      } else {
        discountAppliedEl.hidden = true;
        discountAppliedEl.innerHTML = '';
      }
    }

    function renderItemPrice(item) {
      var discount = item.total_discount || 0;
      var final = item.line_price;
      var original = final + discount;
      if (discount > 0) {
        return '<s class="cart-drawer__item-price-original">' + formatMoney(original) + '</s>' +
          '<span class="cart-drawer__item-price-final">' + formatMoney(final) + '</span>';
      }
      return '<span class="cart-drawer__item-price-regular">' + formatMoney(final) + '</span>';
    }

    function renderCart(cart) {
      if (!cart.item_count) {
        itemsEl.innerHTML = '';
        emptyEl.hidden = false;
        footerEl.hidden = true;
      } else {
        emptyEl.hidden = true;
        footerEl.hidden = false;
        itemsEl.innerHTML = cart.items.map(function (item) {
          var image = item.image
            ? '<img src="' + item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_x128$1$2') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="64" height="64">'
            : '';
          var variant = item.variant_title
            ? '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>'
            : '';
          return (
            '<div class="cart-drawer__item" data-line-key="' + item.key + '">' +
              '<a href="' + item.url + '" class="cart-drawer__item-image" tabindex="-1">' + image + '</a>' +
              '<div class="cart-drawer__item-info">' +
                '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
                variant +
                '<div class="cart-drawer__item-qty">' +
                  '<button type="button" class="cart-drawer__qty-btn" data-qty-decrease aria-label="Menge verringern">−</button>' +
                  '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
                  '<button type="button" class="cart-drawer__qty-btn" data-qty-increase aria-label="Menge erhöhen">+</button>' +
                '</div>' +
              '</div>' +
              '<div class="cart-drawer__item-price">' + renderItemPrice(item) + '</div>' +
              '<button type="button" class="cart-drawer__item-remove" data-remove-item aria-label="Artikel entfernen">' +
                '<svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M1 1l14 14M15 1L1 15"/></svg>' +
              '</button>' +
            '</div>'
          );
        }).join('');
      }
      subtotalEl.textContent = formatMoney(cart.total_price);
      renderShippingBar(cart);
      renderSummary(cart);
      renderDiscount(cart);
      updateCartCountBubbles(cart.item_count);
    }

    function updateCartCountBubbles(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(renderCart);
    }

    function updateLineQuantity(key, quantity) {
      if (isBusy) return;
      setBusy(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          setBusy(false);
        })
        .catch(function () { setBusy(false); });
    }

    function applyDiscount(code) {
      if (isBusy) return;
      setBusy(true);
      discountMsgEl.textContent = '';
      discountMsgEl.className = 'cart-drawer__discount-message';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var applications = cart.cart_level_discount_applications || [];
          if (applications.length > 0) {
            discountMsgEl.textContent = 'Rabattcode angewendet.';
            discountMsgEl.classList.add('is-success');
            discountInput.value = '';
          } else {
            discountMsgEl.textContent = 'Dieser Code ist ungültig, abgelaufen oder gilt nicht für deinen Warenkorb.';
            discountMsgEl.classList.add('is-error');
          }
          renderCart(cart);
          setBusy(false);
        })
        .catch(function () {
          discountMsgEl.textContent = 'Der Code konnte gerade nicht geprüft werden. Bitte versuch es erneut.';
          discountMsgEl.classList.add('is-error');
          setBusy(false);
        });
    }

    function removeDiscount() {
      if (isBusy) return;
      setBusy(true);
      discountMsgEl.textContent = '';
      discountMsgEl.className = 'cart-drawer__discount-message';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          renderCart(cart);
          setBusy(false);
        })
        .catch(function () { setBusy(false); });
    }

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-close]')) {
        closeDrawer();
        return;
      }
      var qtyIncrease = e.target.closest('[data-qty-increase]');
      var qtyDecrease = e.target.closest('[data-qty-decrease]');
      var removeItem = e.target.closest('[data-remove-item]');
      var removeDiscountBtn = e.target.closest('[data-remove-discount]');

      if (qtyIncrease || qtyDecrease || removeItem) {
        var itemEl = e.target.closest('[data-line-key]');
        if (!itemEl) return;
        var key = itemEl.getAttribute('data-line-key');
        var qtyEl = itemEl.querySelector('.cart-drawer__qty-value');
        var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 0;
        if (removeItem) {
          updateLineQuantity(key, 0);
        } else if (qtyIncrease) {
          updateLineQuantity(key, currentQty + 1);
        } else if (qtyDecrease) {
          updateLineQuantity(key, Math.max(0, currentQty - 1));
        }
        return;
      }

      if (removeDiscountBtn) {
        removeDiscount();
      }
    });

    discountApplyBtn.addEventListener('click', function () {
      var code = discountInput.value.trim();
      if (!code) return;
      applyDiscount(code);
    });

    discountInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        discountApplyBtn.click();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('#cart-icon-bubble');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        openDrawer();
      }
    }, true);

    document.addEventListener('cart:refresh', fetchCart);

    // Das native Theme (Vela) feuert nach jedem erfolgreichen "In den Warenkorb" ein jQuery-Event
    // 'drawer.open' auf <body>, um seinen eigenen (jetzt per CSS ausgeblendeten) Drawer zu oeffnen.
    // Wir haengen uns an dasselbe Event, damit unser Drawer stattdessen aufgeht.
    if (window.jQuery) {
      window.jQuery(document.body).on('drawer.open', function () {
        openDrawer();
      });
    }

    window.CartDrawer = { open: openDrawer, close: closeDrawer, refresh: fetchCart };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
